import { render, staticRenderFns } from "./ArticleDetails.vue?vue&type=template&id=360a5de4&scoped=true"
import script from "./ArticleDetails.vue?vue&type=script&lang=js"
export * from "./ArticleDetails.vue?vue&type=script&lang=js"
import style0 from "./ArticleDetails.vue?vue&type=style&index=0&id=360a5de4&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "360a5de4",
  null
  
)

export default component.exports